import * as types from './actionTypes';
import * as selectors from './selectors';
import * as api from '../../../../common/api';

export const fetchShippingOrders = customerId => ({
    types: [types.FETCH_SHIPPING_ORDERS_REQUEST, types.FETCH_SHIPPING_ORDERS_SUCCESS, types.FETCH_SHIPPING_ORDERS_FAILURE],
    apiCall: () => api.getShippingOrders(customerId)
});

export const setActiveOrder = (orderId) => ({
    type: types.SET_ACTIVE_SHIPPING_ORDER,
    orderId   
});

export const setPreviousOrder = (orderId) => ({
    type: types.SET_PREVIOUS_SHIPPING_ORDER,
    orderId   
});

export const setActiveTab = (selectedTabName) => ({
    type: types.SET_ACTIVE_TAB,
    selectedTabName,
});